import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CompanySearch } from '../interfaces/company-search.interface';
import { DDIGCompanySearchOnly } from '../interfaces/DDIGCompanySearchOnly.interface';

@Injectable({
  providedIn: 'root',
})
export class AccountsServiceService {
  accounts = new BehaviorSubject<CompanySearch[]>([]);
  accounts$ = this.accounts.asObservable();

  DDIGaccounts = new BehaviorSubject<DDIGCompanySearchOnly[]>([]);
  DDIGaccounts$ = this.DDIGaccounts.asObservable();

  constructor() {}
}
